import { render, staticRenderFns } from "./GridField.vue?vue&type=template&id=f8877620"
import script from "./GridField.vue?vue&type=script&lang=js"
export * from "./GridField.vue?vue&type=script&lang=js"
import style0 from "./GridField.vue?vue&type=style&index=0&id=f8877620&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports